import { apiClient } from "@kunduz/utility-axios/networkClient";
import axios from "axios";

export function getLearningApiClient(options: {
  token?: string;
  isoCode?: string;
  webSecretKey?: string;
}) {
  return apiClient;
}
